export default "__VITE_ASSET__zuAxpKr3__"